var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.formerror == 0)?_c('GDQQuestionnaire',{attrs:{"api":"1","successurl":_vm.successurl}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }